module.exports = __webpack_public_path__ + "static/media/gato-azul.e7a016b5.svg";